import { createSlice } from "@reduxjs/toolkit";

export const secondCenterModalSlice = createSlice({
  name: "secondCenterModal",
  initialState: {
    isOpen: false,
    content: null,
    maxWidth: "",
    fullScreen: false,
    hasCloseBtn: false,
    onClose: () => {},
    desc: null,
    backgroundcolor: null,
  },
  reducers: {
    openSecondCenterModal: (state, { payload }) => {
      state.isOpen = true;
      state.hasCloseBtn = payload?.hasCloseBtn;
      state.onClose = payload?.onClose;
      state.content = payload?.content;
      state.fullScreen = payload?.fullScreen;
      state.desc = payload?.desc;
      state.maxWidth = payload?.maxWidth;
      state.backgroundcolor = payload?.backgroundcolor;
    },
    closeSecondCenterModal: (state) => {
      state.isOpen = false;
      state.hasCloseBtn = false;
      state.width = "";
      state.onClose = () => {};
      // state.content = null;
      state.fullScreen = false;
      state.desc = null;
      state.backgroundcolor = null;
    },
  },
});

export const { openSecondCenterModal, closeSecondCenterModal } = secondCenterModalSlice.actions;

export default secondCenterModalSlice.reducer;
